import Vue from "vue";
import VueI18n from "vue-i18n";
import LanguageService from "@/services/language.service";


Vue.use(VueI18n);

var messages = {};
var locale = "do";

var locales = localStorage.getItem("locales");
if (locales) {
  messages = JSON.parse(locales as any);
}

var currentLocale = localStorage.getItem("currentLocale");
if (currentLocale) {
  locale = currentLocale;
}

const i18n = new VueI18n({
  locale: locale, // set locale
  fallbackLocale: "do", // set fallback locale
  messages // set locale messages
});

var languageService = new LanguageService();

languageService.getJSON().then(msg => {
  localStorage.setItem("locales", JSON.stringify(msg));
  i18n.setLocaleMessage(locale, msg[locale]);
});

export default i18n;
